import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LDFlagsService } from '@app/shared/services/ld-flags.service';

/**
 * Example usage:
 *
 * <dgx-add-tile
 *   (clickTile)="onAddTileClick()"
 * ></dgx-add-tile>
 */
@Component({
  selector: 'dgx-add-tile',
  styleUrls: ['./add-tile.component.scss'],
  templateUrl: './add-tile.component.html',
})
export class AddTileComponent {
  @Input() public label = '';
  @Output() public clickTile: EventEmitter<any> = new EventEmitter<any>();

  public onClick() {
    this.clickTile.emit();
  }
}
